import { render, staticRenderFns } from "./CombiHousingSituation.vue?vue&type=template&id=7b56b3ae"
import script from "./CombiHousingSituation.vue?vue&type=script&lang=ts"
export * from "./CombiHousingSituation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports